/*global FB */
export const loadSDK = (app) => {
  window.fbAsyncInit = function() {
    try {
      FB.init({
        appId: app,
        cookie: true,
        xfbml: true,
        oauth: true,
        version: "v5.0"
      });
    } catch (e) {
      window.webpackBugsnagClient.metaData = { obj: FB };
      window.webpackBugsnagClient.notify(e);
    }
  };
  (function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "//connect.facebook.net/ja_JP/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, "script", "facebook-jssdk"));
};
